module.exports = __webpack_public_path__ + "img/biaozhun.d9d9582a.d9d9582a.jpg";